export function validURL(url?: string) {
  try {
    if (!url) return false;

    const newUrl = new URL(url);
    return newUrl.protocol === "http:" || newUrl.protocol === "https:";
  } catch (err) {
    return false;
  }
}
